import { useState } from 'react';
import type { DataTableRowEventHandler } from '@/components/custom/erp';
import { CoQuanThue } from '@/types/schemas';

interface UseRowSelectionReturn {
  selectedObj: CoQuanThue | null;
  selectedRowIndex: string | null;
  handleRowClick: DataTableRowEventHandler<CoQuanThue>;
  clearSelection: () => void;
}

export const useRowSelection = (): UseRowSelectionReturn => {
  const [selectedObj, setSelectedObj] = useState<CoQuanThue | null>(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState<string | null>(null);

  const handleRowClick: DataTableRowEventHandler<CoQuanThue> = params => {
    setSelectedRowIndex(params.id.toString());
    setSelectedObj(params.row);
  };

  const clearSelection = () => {
    setSelectedObj(null);
    setSelectedRowIndex(null);
  };

  return {
    selectedObj,
    selectedRowIndex,
    handleRowClick,
    clearSelection
  };
};
